<template>
    
</template>

<script>
export default {
    computed: {
        checkIsHome() {
            return window.location.pathname === '/home';
        },
        checkIsFundraiser() {
            return window.location.pathname === '/teachers';
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/layouts/components/PageHeader.vue